module.exports = __webpack_public_path__ + "img/report_4.29809af8.png";